import Roundable from "../../../mixins/Roundable.mjs";

export default {

    mixins: [Roundable],

    props: {

        // Whether the element shall be rendered as a tile, i.e., no border radius, only on 'xs' screen size devices
        xsTile: {
            type: Boolean,
            default: false
        },

        // Whether the element shall be rendered as a tile, i.e., no border radius, only on 'sm' screen size devices
        smTile: {
            type: Boolean,
            default: false
        },

        // Whether the element shall be rendered as a tile, i.e., no border radius, only on 'md' screen size devices
        mdTile: {
            type: Boolean,
            default: false
        },

        // Whether the element shall be rendered as a tile, i.e., no border radius, only on 'lg' screen size devices
        lgTile: {
            type: Boolean,
            default: false
        },

        // Whether the element shall retrieve no margin
        noSpacing: {
            type: Boolean,
            default: false
        },
    },

    computed: {
        responsiveGridBorderRadiusClass() {
            let roundedClass = this.roundedString;

            if (!roundedClass) {
                return null;
            }

            let borderRadiusClass = [];

            if (this.lgTile) {
                borderRadiusClass.push('lg:rounded-none')
            }

            if (this.mdTile) {
                borderRadiusClass.push('md:rounded-none')

                if (!this.lgTile) {
                    borderRadiusClass.push(`lg:${roundedClass}`)
                }
            }

            if (this.smTile) {
                borderRadiusClass.push('sm:rounded-none')

                if (!this.mdTile) {
                    borderRadiusClass.push(`md:${roundedClass}`)
                }
            }

            if (this.xsTile) {
                borderRadiusClass.push('xs:rounded-none')

                if (!this.smTile) {
                    borderRadiusClass.push(`sm:${roundedClass}`)
                }
            } else {
                borderRadiusClass.push(roundedClass)
            }

            return borderRadiusClass.join(' ')
        }
    }
}
